import { render, staticRenderFns } from "./PositionsPayRangesPage.vue?vue&type=template&id=7cdd9cd2&scoped=true"
import script from "./PositionsPayRangesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PositionsPayRangesPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PositionsPayRangesPage.vue?vue&type=style&index=0&id=7cdd9cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdd9cd2",
  null
  
)

export default component.exports